import { Component, OnInit, ViewChild, ElementRef, Input, HostListener } from '@angular/core';
import { DataService } from '../../services/data.service';
import { NavigationExtras } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  MenuController
} from '@ionic/angular';

@Component({
  selector: 'app-return-policy',
  templateUrl: './return-policy.page.html',
  styleUrls: ['./return-policy.page.scss'],
})
export class ReturnPolicyPage implements OnInit {
  page_no = 0
  issue_list:any=[]
  page_size = 10
  
  constructor(public db: DataService, public navCtrl: NavController,public menu:MenuController,public modal:ModalController) { }

  ngOnInit() {
    this.get_support();

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }


  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modal.dismiss();
  }
  

  get_support() {
    // let data = { start: this.page_no, length: this.page_size,doctype: 'Return Policy' }; 
    this.db.get_return_policies()
      .subscribe((res: any) => {
        console.log(res);
        this.issue_list = res.message
      })
  }

   async go_to_product(item){
    if(item){
      item.status = 'success'
      await this.modal.dismiss(item);
    };
   }
  }

